import {css} from 'aphrodite';
import React from 'react';

import {QueryingChartContent} from 'charts/chart-content/ChartContent';
import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepRawData} from 'pipelines/PipelineTypes';

import {popoverPreviewStyles as styles} from './PopoverPreviewStyles';

/**
 * Popover contents for a chart.
 */
export default function ChartPopoverContents({
  rawData,
}: {
  rawData: PipelineStepRawData<PipelineStepDataKind.CHART>;
}): JSX.Element {
  return (
    <div className={css(styles.fixedDimensionPreview)}>
      <QueryingChartContent chartId={rawData.id} />
    </div>
  );
}
